import { memo, SyntheticEvent, useState } from 'react';

import { useInView } from '@app/dashboard/hooks/useInView';

const LazyImage = ({
  src,
  alt,
  className,
}: {
  src: string;
  alt: string;
  className: string;
}) => {
  const { ref, isInView } = useInView({
    once: true,
    threshold: 0.5,
  });
  const [hasLoaded, setHasLoaded] = useState(false);

  const handleLoad = (e: SyntheticEvent<HTMLImageElement, Event>) => {
    setHasLoaded(true);
  };

  return (
    <img
      ref={ref}
      className={className}
      src={isInView ? src : undefined}
      alt={alt}
      decoding="async"
      loading="lazy"
      onLoad={handleLoad}
      style={{ opacity: hasLoaded ? 1 : 0, transition: 'opacity 0.3s ease' }}
    />
  );
};

export default memo(LazyImage);
